import { render, staticRenderFns } from "./NotificationBox.vue?vue&type=template&id=dd4e4844&scoped=true"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"
import style0 from "./NotificationBox.vue?vue&type=style&index=0&id=dd4e4844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4e4844",
  null
  
)

export default component.exports